import Glide from '@glidejs/glide'
import { getScreenWidth } from './utils';


const initAboutSliders = () => {

    const setupBlock = (block) => {

        /* BOOKMARKS SLIDER */

        const bookmarksSlider = block.querySelector(".glide-menu");
        if (!bookmarksSlider) return;

        let bookmarksSliderOptions = {
            type: 'carousel',
            autoplay: false,
            touchAngle: 0,
            animationDuration: 1500,
            perView: 5,
            focusAt: 'center',
            peek: 250,
            gap: 100,
            breakpoints: {
                1699: {
                    perView: 5,
                    peek: 200,
                    gap: 50,
                },
                1599: {
                    perView: 5,
                    peek: 130,
                    gap: 50,
                },
                1439: {
                    perView: 5,
                    peek: 100,
                    gap: 30,
                },
                1349: {
                    perView: 3,
                    peek: 200,
                    gap: 80,
                },
                1249: {
                    perView: 3,
                    peek: 150,
                    gap: 50,
                },
                1023: {
                    perView: 1,
                    peek: 250,
                    gap: 30,
                },
                850: {
                    perView: 1,
                    peek: 200,
                    gap: 30,
                },
                670: {
                    perView: 1,
                    peek: 150,
                    gap: 40,
                },
                450: {
                    perView: 1,
                    peek: 100,
                    gap: 20,
                },
                400: {
                    perView: 1,
                    peek: 70,
                    gap: 10,
                },
                340: {
                    perView: 1,
                    peek: 0,
                    gap: 0,
                },
            }
        }

        const glideMenu = new Glide(bookmarksSlider, bookmarksSliderOptions);

        glideMenu.mount();


        /* CONTENT SLIDER */

        const slider = block.querySelector(".glide");
        if (!slider) return;

        const rootStyle = getComputedStyle(document.documentElement);
        const containerValue = parseInt(rootStyle.getPropertyValue('--cont-max-w').trim());
        const paddingValue = parseInt(rootStyle.getPropertyValue('--cont-px').trim());
        const gapValueOverXL = (getScreenWidth() - containerValue + paddingValue*2) / 2;
        let   gapValue = (getScreenWidth() * 5.55) / 100; // padding set to 5.55vw

        if(gapValue < 20) gapValue = 20;

        let options = {
            type: 'carousel',
            autoplay: false,
            touchRatio: 0.2,
            touchAngle: 30,
            swipeTreshold: 40,
            dragTreshold: 60,
            animationDuration: 1500,
            perView: 1,
            peek: gapValueOverXL,
            gap: gapValueOverXL + 100,
            breakpoints: {
                1439: {
                    perView: 1,
                    peek: gapValue,
                    gap: gapValue + 50,
                },
                1023: {
                    perView: 1,
                    peek: gapValue,
                    gap: gapValue + 50,
                },
            }
        }
    
        const glide = new Glide(slider, options);

        /* setup control arrows and buttons */

        const arrowLeft  = block.querySelector(".js-left");
        const arrowRight = block.querySelector(".js-right");
        const next       = block.querySelector(".js-next");
        const buttons    = block.querySelectorAll(".js-button");

        if (arrowLeft) {
            arrowLeft.addEventListener("click", () => {
                glide.go(`<`);
            })
        }

        if (arrowRight) {
            arrowRight.addEventListener("click", () => {
                glide.go(`>`);
            })
        }

        if (next) {
            next.addEventListener("click", () => {
                glide.go(`>`);
            })
        }

        if (buttons) {
            for (let i=0; i<buttons.length; i++) {
                buttons[i].addEventListener('click', () => {

                    if(i-(buttons.length/3) < 0) {
                        glide.go(`=${i}`);
                    }
                    else if (i-(buttons.length/3) >= buttons.length/3) {
                        glide.go(`=${i-(buttons.length/3*2)}`);
                    }
                    else {
                        glide.go(`=${i-(buttons.length/3)}`);
                    }
                })
            }
        }

        glide.on(['run'], () => {
            glideMenu.go(`=${glide.index}`);  
        })


        /* change slider cursor */

        slider.addEventListener('mousedown', () => { slider.style.cursor = 'grabbing' })
        slider.addEventListener('mouseup', () => { slider.style.cursor = 'grab' })
        slider.addEventListener('mouseenter', () => { slider.style.cursor = 'grab' })

        /* mount */

        glide.mount();
    }

    let blocks = document.querySelectorAll(".js-about-slider");

    if (!blocks) return;
    
    blocks.forEach(block => {
        setupBlock(block);
    });
    
}

export { initAboutSliders }
